import { AiExpertTypeMapToRole, initialAiExpertsQuotaMap, initialAiExpertsPermissionMap, } from '@/api/logical/ai_staff';
import { api } from '@/api/api';
import { apis } from '@/config';
export class AiStaffApiImpl {
    constructor() {
        this.name = 'aiStaffApiImpl';
        this.http = api.getDataTransApi();
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.dataTrackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
    }
    init() {
        return this.name;
    }
    errorHandler(error) {
        var _a;
        this.eventApi.sendSysEvent({
            auto: true,
            eventSeq: 0,
            eventName: 'error',
            eventLevel: 'error',
            eventData: {
                title: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || (error === null || error === void 0 ? void 0 : error.message) || '网络错误',
                content: '',
                popupType: 'toast',
                popupLevel: 'error',
            },
        });
    }
    async get(url, req, config, options = {}) {
        try {
            const { data } = await this.http.get(url, req, config);
            if (!data) {
                throw new Error('no data');
            }
            if (!data.success) {
                throw data;
            }
            return options.fullData ? data : data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async post(url, body, config) {
        config = Object.assign({ contentType: 'json', noEnqueue: false }, (config || {}));
        try {
            const { data } = await this.http.post(url, body, config);
            if (!data) {
                throw new Error('no data');
            }
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async delete(url, req, config) {
        try {
            const { data } = await this.http.delete(url, req, config);
            if (!data) {
                throw new Error('no data');
            }
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    getStaffExists(config) {
        return this.get(this.systemApi.getUrl('getAiStaffExists'), undefined, config);
    }
    createStaff(req) {
        return this.post(this.systemApi.getUrl('createAiStaff'), req);
    }
    deleteStaff(req) {
        return this.delete(this.systemApi.getUrl('deleteAiStaff'), req);
    }
    updateStaff(req) {
        return this.post(this.systemApi.getUrl('updateAiStaff'), req);
    }
    getStaffInfo(req, config) {
        return this.get(this.systemApi.getUrl('getAiStaffInfo'), req, config);
    }
    switchStaffStatus(req) {
        return this.post(this.systemApi.getUrl('switchAiStaffStatus'), req);
    }
    switchMarketingExpertStatus(req) {
        return this.post(this.systemApi.getUrl('switchMarketingExpertStatus'), req);
    }
    getEffectiveProgress() {
        return this.get(this.systemApi.getUrl('getEffectiveProgress'));
    }
    getEffectiveProgressV2() {
        return this.get(this.systemApi.getUrl('getEffectiveProgressV2'));
    }
    getWorkPlanCalendar(req) {
        return this.post(this.systemApi.getUrl('getWorkPlanCalendar'), req);
    }
    getWorkPlanCalendarItem() {
        return this.get(this.systemApi.getUrl('getWorkPlanCalendarItem'));
    }
    getMarketingReplyList(req) {
        return this.post(this.systemApi.getUrl('getMarketingReplyList'), req);
    }
    getWorkPlanCalendarItemV2(req) {
        return this.post(this.systemApi.getUrl('getWorkPlanCalendarItemV2'), req);
    }
    getWorkPlanCalendarItemV3(req) {
        return this.post(this.systemApi.getUrl('getWorkPlanCalendarItemV3'), req);
    }
    getAiTeamCalendarItem() {
        return this.get(this.systemApi.getUrl('getAiTeamCalendarItem'), undefined);
    }
    getAiTeamCalendarItemV2() {
        return this.get(this.systemApi.getUrl('getAiTeamCalendarItemV2'), undefined);
    }
    getAiTeamCalendarItemV3() {
        return this.get(this.systemApi.getUrl('getAiTeamCalendarItemV3'));
    }
    getAiSiteCalendarItemV3() {
        return this.get(this.systemApi.getUrl('getAiSiteCalendarItemV3'), undefined);
    }
    getAiMediaCalendarItemV3() {
        return this.get(this.systemApi.getUrl('getAiMediaCalendarItemV3'), undefined);
    }
    getAiTeamCalendarInfoV3(res) {
        return this.post(this.systemApi.getUrl('getAiTeamCalendarInfoV3'), res);
    }
    getAiSiteCalendarInfoV3(res) {
        return this.post(this.systemApi.getUrl('getAiSiteCalendarInfoV3'), res);
    }
    getAiMediaCalendarInfoV3(res) {
        return this.post(this.systemApi.getUrl('getAiMediaCalendarInfoV3'), res);
    }
    checkExpertTaskExists(res) {
        return this.post(this.systemApi.getUrl('checkExpertTaskExists'), res);
    }
    getAiMarketingCalendarItem() {
        return this.get(this.systemApi.getUrl('getAiMarketingCalendarItem'), undefined);
    }
    getAiSiteCalendarItem() {
        return this.get(this.systemApi.getUrl('getAiSiteCalendarItem'), undefined);
    }
    getAiSiteCalendarItemV2() {
        return this.get(this.systemApi.getUrl('getAiSiteCalendarItemV2'), undefined);
    }
    getAiSiteCalendarInfo(req) {
        return this.post(this.systemApi.getUrl('getAiSiteCalendarInfo'), req);
    }
    getAiSiteCalendarInfoV2(req) {
        return this.post(this.systemApi.getUrl('getAiSiteCalendarInfoV2'), req);
    }
    getAiTeamCalendarInfo(req) {
        return this.post(this.systemApi.getUrl('getAiTeamCalendarInfo'), req);
    }
    getAiTeamCalendarInfoV2(req) {
        return this.post(this.systemApi.getUrl('getAiTeamCalendarInfoV2'), req);
    }
    getAiMarketingCalendarInfo(req) {
        return this.post(this.systemApi.getUrl('getAiMarketingCalendarInfo'), req);
    }
    getAiOperationCalendarItem() {
        return this.get(this.systemApi.getUrl('getAiOperationCalendarItem'), undefined);
    }
    getAiOperationCalendarInfo(req) {
        return this.post(this.systemApi.getUrl('getAiOperationCalendarInfo'), req);
    }
    getAiMediaCalendarItem() {
        return this.get(this.systemApi.getUrl('getAiMediaCalendarItem'), undefined);
    }
    getAiMediaCalendarInfo(req) {
        return this.post(this.systemApi.getUrl('getAiMediaCalendarInfo'), req);
    }
    applyAiStaffSelfCheckEmail(req) {
        return this.post(this.systemApi.getUrl('applyAiStaffSelfCheckEmail'), req);
    }
    getAiStaffSelfCheckEmailDetail(req) {
        return this.get(this.systemApi.getUrl('getAiStaffSelfCheckEmailDetail'), req);
    }
    generateAiStaffSelfCheckEmail(req) {
        const url = `${this.systemApi.getUrl('generateAiStaffSelfCheckEmail')}?self_check_id=${req.self_check_id}`;
        return this.post(url, req);
    }
    getAiTeamCsmQRcode() {
        return this.get(this.systemApi.getUrl('getAiTeamCsmQRcode'));
    }
    judgeAiTeamCustomerTaskQuota(req) {
        return this.post(this.systemApi.getUrl('judgeAiTeamCustomerTaskQuota'), req);
    }
    getStaffList() {
        return this.get(this.systemApi.getUrl('getStaffList'));
    }
    getTradeAnalysisReport(req) {
        return this.get(this.systemApi.getUrl('getAiStaffTradeAnalysisReport'), req);
    }
    getTradeAnalysisReportDetail(req) {
        return this.get(this.systemApi.getUrl('getAiStaffTradeAnalysisReportDetail'), req);
    }
    createTradeAnalysisReport(req) {
        return this.post(this.systemApi.getUrl('createAiStaffTradeAnalysisReport'), req);
    }
    deleteTradeAnalysisReport(req) {
        const url = `${this.systemApi.getUrl('deleteAiStaffTradeAnalysisReport')}?report_id=${req.report_id}`;
        return this.post(url, req);
    }
    getEnterpriseInfo() {
        return this.get(this.systemApi.getUrl('getAiStaffEnterpriseInfo'));
    }
    getIndustries() {
        return this.get(this.systemApi.getUrl('getAiStaffIndustries'));
    }
    getReservedPostList(req) {
        return this.get(this.systemApi.getUrl('getAiStaffReservedPostList'), req);
    }
    getPostDetail(req) {
        return this.get(this.systemApi.getUrl('getPostDetail'), req);
    }
    postGenerate(req) {
        return this.post(this.systemApi.getUrl('postGenerate'), req);
    }
    postTranslate(req) {
        return this.post(this.systemApi.getUrl('postTranslate'), req);
    }
    remainQuota(req) {
        return this.post(this.systemApi.getUrl('remainQuota'), req);
    }
    buildWebsite(req) {
        return this.post(this.systemApi.getUrl('buildAiStaffWebsite') + `?staff_id=${req.staff_id}`, req);
    }
    getSiteData(req) {
        return this.get(this.systemApi.getUrl('getAiStaffSiteData'), req);
    }
    getContactBehavior(req) {
        return this.get(this.systemApi.getUrl('getContactBehavior'), req);
    }
    getAiProductViewData(req) {
        return this.get(this.systemApi.getUrl('getAiProductViewData'), req);
    }
    getAiLinkBtnViewData(req) {
        return this.get(this.systemApi.getUrl('getAiLinkBtnViewData'), req);
    }
    getAiCustomerClueInfo(req) {
        return this.post(this.systemApi.getUrl('getAiCustomerClueInfo'), req.clueIds);
    }
    getWeeklyReports(req) {
        return this.get(this.systemApi.getUrl('getAiStaffWeeklyReports'), req);
    }
    getWeeklyReportDetail(req) {
        return this.get(this.systemApi.getUrl('getAiStaffWeeklyReportDetail'), req);
    }
    readWeeklyReport(req) {
        return this.post(this.systemApi.getUrl('readAiStaffWeeklyReport') + `?reportId=${req.reportId}`, req);
    }
    isAiTeamExist(config) {
        return this.get(this.systemApi.getUrl('isAiTeamExist'), undefined, config);
    }
    doAiTeamOnboarding(req) {
        return this.post(this.systemApi.getUrl('doAiTeamOnboarding'), req);
    }
    deleteAiTeam(req) {
        return this.delete(this.systemApi.getUrl('deleteAiTeam'), req);
    }
    eventProgressList(req) {
        return this.post(this.systemApi.getUrl('eventProgressList'), req);
    }
    eventCompleteList(req) {
        return this.post(this.systemApi.getUrl('eventCompleteList'), req);
    }
    getAiTeamCompanyInfo(req) {
        return this.get(this.systemApi.getUrl('getAiTeamCompanyInfo'), req);
    }
    getAiTeamDeatil(req, config) {
        return this.get(this.systemApi.getUrl('getAiTeamDeatil'), req, config).then((res) => {
            var _a, _b, _c, _d;
            if (res) {
                try {
                    const marketing_expert = (_a = res.marketing_expert) === null || _a === void 0 ? void 0 : _a[0];
                    const operation_expert = (_b = res.operation_expert) === null || _b === void 0 ? void 0 : _b[0];
                    const social_media_expert = (_c = res.social_media_expert) === null || _c === void 0 ? void 0 : _c[0];
                    const website_building_expert = (_d = res.website_building_expert) === null || _d === void 0 ? void 0 : _d[0];
                    const trackInfo = {
                        team_id: res.team_id,
                        create_time: res.create_time,
                        marketing_expert_id: marketing_expert === null || marketing_expert === void 0 ? void 0 : marketing_expert.expert_id,
                        marketing_expert_task_key: JSON.stringify(marketing_expert === null || marketing_expert === void 0 ? void 0 : marketing_expert.task_key),
                        marketing_expert_create_time: marketing_expert === null || marketing_expert === void 0 ? void 0 : marketing_expert.create_time,
                        operation_expert_id: operation_expert === null || operation_expert === void 0 ? void 0 : operation_expert.expert_id,
                        operation_expert_task_key: JSON.stringify(operation_expert === null || operation_expert === void 0 ? void 0 : operation_expert.task_key),
                        operation_expert_create_time: operation_expert === null || operation_expert === void 0 ? void 0 : operation_expert.create_time,
                        social_media_expert_id: social_media_expert === null || social_media_expert === void 0 ? void 0 : social_media_expert.expert_id,
                        social_media_expert_create_time: social_media_expert === null || social_media_expert === void 0 ? void 0 : social_media_expert.create_time,
                        website_building_expert_id: website_building_expert === null || website_building_expert === void 0 ? void 0 : website_building_expert.expert_id,
                        website_building_expert_create_time: website_building_expert === null || website_building_expert === void 0 ? void 0 : website_building_expert.create_time,
                    };
                    this.dataTrackApi.track('ai_team_detail_summary', trackInfo);
                }
                catch (_e) {
                }
            }
            return res;
        });
    }
    getAiTeamWeekyReport(req) {
        return this.post(this.systemApi.getUrl('getAiTeamWeekyReport'), req);
    }
    getAiTeamExpertList(req) {
        return this.get(this.systemApi.getUrl('getAiTeamExpertList'), req);
    }
    getAllAiTeam() {
        return this.get(this.systemApi.getUrl('getAllAiTeam'));
    }
    getAIExpertOperateTaskList(req) {
        return this.get(this.systemApi.getUrl('getAIExpertOperateTaskList'), req);
    }
    listOperateTaskV2(req) {
        return this.get(this.systemApi.getUrl('listOperateTaskV2'), req, {}, { fullData: true });
    }
    checkProductParseLink(req) {
        return this.post(this.systemApi.getUrl('checkProductParseLink'), req, { contentType: 'form' });
    }
    listEmployeeOperateSite(req) {
        return this.get(this.systemApi.getUrl('listEmployeeOperateSite'), req);
    }
    addProductToSite(req) {
        return this.post(this.systemApi.getUrl('addProductToSite'), req);
    }
    existProductParseTask() {
        return this.get(this.systemApi.getUrl('existProductParseTask'));
    }
    updateAiteam(req) {
        return this.post(this.systemApi.getUrl('updateAiteam'), req);
    }
    doMarketingExpertOnboarding(req) {
        return this.post(this.systemApi.getUrl('doMarketingExpertOnboarding'), req);
    }
    createMarketingExpertTask(req) {
        return this.post(this.systemApi.getUrl('createMarketingExpertTask'), req);
    }
    getMarketingExpertTaskKeys(req) {
        return this.get(this.systemApi.getUrl('getMarketingExpertTaskKeys'), req);
    }
    getMarketingExpertOverview(req) {
        return this.get(this.systemApi.getUrl('getMarketingExpertOverview'), req);
    }
    getMarketingExpertLatestTaskKey(req) {
        return this.get(this.systemApi.getUrl('getMarketingExpertLatestTaskKey'), req);
    }
    updateMarketingExpert(req) {
        return this.post(this.systemApi.getUrl('updateMarketingExpert'), req);
    }
    getMarketingExpertSendTimeItems() {
        return this.get(this.systemApi.getUrl('getMarketingExpertSendTimeItems'));
    }
    getEventTypeList(req) {
        return this.get(this.systemApi.getUrl('eventTypeList'), req);
    }
    getMarketingExpertEmailConfigTips(req) {
        return this.post(this.systemApi.getUrl('getMarketingExpertEmailConfigTips'), req);
    }
    getMarketingExpertSubmitEmailTemplateTask(req) {
        return this.post(this.systemApi.getUrl('getMarketingExpertSubmitEmailTemplateTask'), req);
    }
    getMarketingExpertGetEmailTemplateResult(req) {
        return this.get(this.systemApi.getUrl('getMarketingExpertGetEmailTemplateResult'), req);
    }
    getEdmTaskSplit(req) {
        return this.post(this.systemApi.getUrl('getEdmTaskSplit'), req);
    }
    getEdmTaskRecal(req) {
        return this.post(this.systemApi.getUrl('getEdmTaskRecal'), req);
    }
    aiStaffValidateReplyEmail(req) {
        return this.get(this.systemApi.getUrl('aiStaffValidateReplyEmail'), req);
    }
    getAiStaffSenderList() {
        return this.get(this.systemApi.getUrl('getAiStaffSenderList'), null);
    }
    aiStaffReplyEmailCheck(req) {
        return this.get(this.systemApi.getUrl('aiStaffReplyEmailCheck'), req);
    }
    doSnsExpertOnboarding(req) {
        return this.post(this.systemApi.getUrl('doAiSnsExpertOnboarding') + `?team_id=${req.team_id}`, req);
    }
    bindSnsExpertAccount(req) {
        return this.post(this.systemApi.getUrl('bindAiSnsExpertAccount'), req);
    }
    getWebSiteExpertCalendarInfo(req) {
        return this.post(this.systemApi.getUrl('getWebSiteExpertCalendarInfo'), req);
    }
    getWebSiteExpertCalendarItems() {
        return this.get(this.systemApi.getUrl('getWebSiteExpertCalendarItems'));
    }
    createWebSiteBuildingExpertTask(req) {
        return this.post(this.systemApi.getUrl('createWebSiteBuildingExpertTask'), req);
    }
    getWebSiteBuildingExpertDetail(req) {
        return this.get(this.systemApi.getUrl('getWebSiteBuildingExpertDetail'), req);
    }
    onboardingWebsiteBuildingExpert(req) {
        return this.post(this.systemApi.getUrl('onboardingWebsiteBuildingExpert'), req);
    }
    getWebSiteBuildingExpertOverview(req) {
        return this.get(this.systemApi.getUrl('getWebSiteBuildingExpertOverview'), req);
    }
    getWebSiteBuildingExpertSendTimeItem() {
        return this.get(this.systemApi.getUrl('getWebSiteBuildingExpertSendTimeItem'));
    }
    updateWebSiteBuildingExpert(req) {
        return this.post(this.systemApi.getUrl('updateWebSiteBuildingExpert'), req);
    }
    getSiteOperateTask(req) {
        return this.get(this.systemApi.getUrl('getSiteOperateTask'), req);
    }
    getOperateTaskV2(req) {
        return this.get(this.systemApi.getUrl('getOperateTaskV2'), req);
    }
    updateSiteTaskConfig(req) {
        return this.post(this.systemApi.getUrl('updateSiteTaskConfig'), req);
    }
    getSiteTaskConfig(req) {
        return this.get(this.systemApi.getUrl('getSiteTaskConfig'), req);
    }
    getAiTeamExpertsQuotas(config) {
        return this.get(this.systemApi.getUrl('getAiTeamExpertsQuotas'), undefined, config).then((res) => {
            const map = Object.assign({}, initialAiExpertsQuotaMap);
            res.forEach(item => {
                const role = AiExpertTypeMapToRole[item.expert_type];
                if (role) {
                    map[role] = {
                        totalQuota: +(item.total_quota || 0),
                        remainQuota: +(item.remain_quota || 0),
                        usedQuota: +(item.used_quota || 0),
                    };
                }
            });
            return map;
        });
    }
    getAiTeamExpertsPermissions(config) {
        return this.get(this.systemApi.getUrl('getAiTeamExpertsPermissions'), undefined, config).then((res) => {
            const map = Object.assign({}, initialAiExpertsPermissionMap);
            res.forEach(item => {
                const role = AiExpertTypeMapToRole[item.expert_type];
                if (role) {
                    map[role] = {
                        has_permission: item.has_permission,
                        missing_permissions: item.missing_permissions || [],
                    };
                }
            });
            return map;
        });
    }
    deleteMarketingExpert(exportId) {
        return this.delete(this.systemApi.getUrl('deleteMarketingExpert'), { expert_id: exportId });
    }
    deleteSiteExpert(exportId) {
        return this.delete(this.systemApi.getUrl('deleteSiteExpert'), { expert_id: exportId });
    }
    deleteSnsExpert(exportId) {
        return this.delete(this.systemApi.getUrl('deleteSnsExpert'), { expert_id: exportId });
    }
    deleteOperationExpert(exportId) {
        return this.delete(this.systemApi.getUrl('deleteOperationExpert'), { expert_id: exportId });
    }
    startSiteTask(req) {
        return this.post(this.systemApi.getUrl('startSiteTask'), req, { contentType: 'form' });
    }
    pauseSiteTask(req) {
        return this.post(this.systemApi.getUrl('pauseSiteTask'), req, { contentType: 'form' });
    }
    doSnsExpertOnboardingV2(req, config) {
        return this.post(this.systemApi.getUrl('doAiSnsExpertOnboardingV2'), req, config);
    }
    doSnsExpertCreateTaskV2(req, config) {
        return this.post(this.systemApi.getUrl('doAiSnsExpertCreateTaskV2'), req, config);
    }
    updateSnsExpertHistoryFlag(req) {
        return this.get(this.systemApi.getUrl('updateSnsExpertHistoryFlag'), req);
    }
    saveChatFlowDraft(req) {
        return this.post(this.systemApi.getUrl('saveAiTeamChatFlowDraft'), req);
    }
    getChatFlowDraft(req) {
        return this.post(this.systemApi.getUrl('getAiTeamChatFlowDraft'), req);
    }
    updateIntendedCustomerNotifyRule(req) {
        return this.post(this.systemApi.getUrl('updateIntendedCustomerNotifyRule'), req);
    }
    onboardingOperationExpert(req) {
        return this.post(this.systemApi.getUrl('onboardingOperationExpert'), undefined, { params: req });
    }
    createLeadsDigTask(req) {
        return this.post(this.systemApi.getUrl('createLeadsDigTask'), req);
    }
}
const aiStaffApiImpl = new AiStaffApiImpl();
api.registerLogicalApi(aiStaffApiImpl);
export default aiStaffApiImpl;
